var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.announcements.length
    ? _c(
        "div",
        { staticClass: "announcement-banner" },
        [
          _vm._l(_vm.announcements, function (item) {
            return _c(
              "v-alert",
              {
                key: item.id,
                staticClass: "mb-0",
                attrs: {
                  type: item.type,
                  dense: "",
                  text: "",
                  dismissible: "",
                },
                on: {
                  input: function ($event) {
                    return _vm.dismiss(item)
                  },
                },
              },
              [_vm._v("\n        " + _vm._s(item.message) + "\n    ")]
            )
          }),
          _vm._v(" "),
          _vm.remaining
            ? _c("div", { staticClass: "text-caption grey--text px-4 py-1" }, [
                _vm.remaining === 1
                  ? _c("span", [
                      _vm._v("1 more announcement. Close one above to see it."),
                    ])
                  : _c("span", [
                      _vm._v(
                        _vm._s(_vm.remaining) +
                          " more announcements. Close one above to see the next."
                      ),
                    ]),
              ])
            : _vm._e(),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }